import { BreadrumbsWrapper } from './Breadrumbs.styles';
import { useRouter } from 'next/router';
import { ArrowRight, BreadcrumbsHome } from '@/icons';
import { capitalizeFirstLetter } from '@/utils/string';
import { useEffect, useState } from 'react';
import Link from 'next/link';

interface Props {
  name?: string;
  id?: string;
}

const Breadrumbs = ({ name, id }: Props) => {
  const router = useRouter();
  const [crumbs, setCrumbs] = useState<any>([]);

  useEffect(() => {
    const paths = router.asPath.split(`/`).map((el) => el.split(`?`)[0]);
    setCrumbs(!router.query.category ? paths : [...paths, name]);
  }, [router, name]);

  return (
    <BreadrumbsWrapper>
      <ol>
        {crumbs.map((el: string, ind: number) => (
          <li key={el}>
            {el === `` ? (
              <>
                <BreadcrumbsHome />
                <Link href="/" passHref>
                  Home
                </Link>
              </>
            ) : (
              <>
                <ArrowRight />
                {ind === crumbs.length - 1 ? (
                  name && el === id ? (
                    name
                  ) : (
                    capitalizeFirstLetter(el)
                  )
                ) : (
                  <Link href={`${crumbs.slice(0, ind + 1).join(`/`)}`} passHref>
                    {capitalizeFirstLetter(el)}
                  </Link>
                )}
              </>
            )}
          </li>
        ))}
      </ol>
    </BreadrumbsWrapper>
  );
};

export default Breadrumbs;
